export const FeatureTypes = {
    FEATURE: 'feature', // complex feature
    IMAGES: 'images', // complex feature images section
    CONFIG: 'config', // configuration: should both display and edit values
    UPDATE: 'update', // get inputs and update something in the db
    READ: 'read' // get inputs and get something from the db
}